import {
  AbstractControl,
  FormControl,
  FormGroupDirective,
  NgForm,
  ValidationErrors,
  ValidatorFn
} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export function requireCompleteDate(message: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const dateValue = control.value;
    if (!dateValue) {
      return null;
    }
    return isNaN(new Date(dateValue).getTime()) ? { msg: message } : null;
  };
}

export class PatientPortalErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    if (!control) {
      return false;
    }
    const isSubmitted = !!form && form.submitted;
    return control.invalid && (control.dirty || control.touched || isSubmitted);
  }
}
